var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondIconPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 30 25",
    fill: "#DC569E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10586 9.61538L12.2301 19.6064L7.83642 9.61538H3.10586ZM14.9982 21.2139L20.1095 9.61538H9.88682L14.9982 21.2139ZM7.88036 7.69231L10.8681 1.92308H7.03091L2.81295 7.69231H7.88036ZM17.7662 19.6064L26.8905 9.61538H22.1599L17.7662 19.6064ZM10.004 7.69231H19.9923L17.0046 1.92308H12.9917L10.004 7.69231ZM22.116 7.69231H27.1834L22.9654 1.92308H19.1283L22.116 7.69231ZM24.181 0.390625L29.805 8.08293C29.9417 8.26322 30.0051 8.47105 29.9954 8.70643C29.9856 8.94181 29.9026 9.14463 29.7464 9.3149L15.6865 24.6995C15.5108 24.8998 15.2813 25 14.9982 25C14.715 25 14.4856 24.8998 14.3098 24.6995L0.249953 9.3149C0.0937324 9.14463 0.0107402 8.94181 0.000976379 8.70643C-0.00878742 8.47105 0.0546773 8.26322 0.19137 8.08293L5.81532 0.390625C5.99106 0.130208 6.24004 0 6.56225 0H23.4341C23.7563 0 24.0053 0.130208 24.181 0.390625Z",
    fill: "#DC569E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIconPink);
export default __webpack_public_path__ + "static/media/diamond-icon-pink.c448fb9eeee60d13938e859f3f650a63.svg";
export { ForwardRef as ReactComponent };